/*
  TODO: Migrate to proper VUe3 composition api:
  https://glittrsoftware.visualstudio.com/glittr.core/_workitems/edit/8089
*/

export default class DataEvent<TData extends any[] = []> {
  listeners: ((...args: TData) => void)[] = [];

  addEventListener(listener: (...args: TData) => void) {
    this.listeners.push(listener);
  }

  removeEventListener(listener: (...args: TData) => void) {
    this.listeners = this.listeners.filter((i) => i !== listener);
  }

  invoke(...args: TData) {
    this.pruneListeners();
    this.listeners.forEach((listener) => {
      listener(...args);
    });
  }

  pruneListeners() {
    this.listeners = this.listeners.filter((i) => i !== undefined && i !== null);
  }
}
